import apiV2 from '.'

// Rendu du badge participant via la nouvelle interface v2 (badgeTemplates, service apix). Le PDF
// est renvoyé inline → on le convertit en URL blob, ouverte ensuite via window.open (même contrat
// que l'ancien flux v1 qui renvoyait une URL). Le template est résolu côté serveur
// (réglage FO_EVENT_BADGE_TEMPLATE_ID de l'événement) : plus besoin de badgeId côté front.
const badgeQuery = ({ domainId, eventId, userId, templateId }) => ({
  url: `/domains/${domainId}/events/${eventId}/users/${userId}/badge/render`,
  method: 'POST',
  body: templateId ? { templateId } : {},
  responseHandler: async response =>
    (response.ok ? URL.createObjectURL(await response.blob()) : response.text()),
})

export const badgeApi = apiV2.injectEndpoints({
  endpoints: builder => ({
    // Mutation : téléchargement à la demande (Home, écran Confirmation, route /badge/.../download).
    renderUserBadge: builder.mutation({ query: badgeQuery }),
    // Query : préchargement pour Safari (qui bloque window.open après un await).
    getRenderUserBadge: builder.query({ query: badgeQuery }),
  }),
})

export const { useRenderUserBadgeMutation, useGetRenderUserBadgeQuery } = badgeApi
